export const REDUCER_NAME = 'jurisdictionAnalyzerDocuments';
